import { TVNavParams } from '@euler/app/Routes.tv';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { memo, useCallback } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

export const BackButton = memo(
  ({
    style,
    color,
    onPress,
  }: {
    style?: StyleProp<ViewStyle>;
    color?: string;
    onPress?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        css={`
          width: ${rpx(64)}px;
          height: ${rpx(64)}px;
          align-items: center;
          justify-content: center;
        `}
        style={style}
        onPress={onPress}
      >
        <Icon name="arrow-back-circle-outline" size={rpx(64)} color={color} />
      </TouchableOpacity>
    );
  },
);

export const WiredBackButton = memo(
  ({ style, color }: { color?: string; style?: StyleProp<ViewStyle> }) => {
    const navigation = useNavigation<StackNavigationProp<TVNavParams>>();

    const onPress = useCallback(() => {
      if (navigation.canGoBack()) {
        navigation.goBack();
      } else {
        navigation.replace('Home', {});
      }
    }, [navigation]);

    return <BackButton color={color} style={style} onPress={onPress} />;
  },
);
